import { Box } from "@repo/ui/core";
import { AgendaGrid } from "@components/AgendaGrid";
import { useCustomerData } from "@contexts/CustomerContext";

export function AgendaSlide() {
  const { agendaSections } = useCustomerData();

  return (
    <Box w="100%" maw={1400} px="xl">
      <AgendaGrid sections={agendaSections} />
    </Box>
  );
}
